import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import { Button } from "../components/ui/button";
import { Modal } from "../components/ui/modal";
import ResumeContext from "../context/ResumeContext";
import { ResumeDataService } from "../services/create-resume/resume-data";
import GenerateResumePopup from "../Views/ManageResumes/ResumeListItem/GenerateResumePopup";
import useSetResumeIdCookie from "./use-SetResumeIdCookie";

const useMyResumesUtilities = (resume) => {
	const navigate = useNavigate();

	const { setResumeIdCookie } = useSetResumeIdCookie();

	const { resumeData } = useContext(ResumeContext);

	const [resumeGenerateSpinner, setresumeGenerateSpinner] = useState(false);

	let extrasSections = Object.getOwnPropertyNames(resumeData.extras).filter(
		(section) => section !== "activeReferencesIndex",
	);
	let lastUpdatedOn = resumeData.lastUpdatedOn;
	const resumeDataService = new ResumeDataService();
	const [, setresumeGenerated] = useState(false);
	const [generateNewResume, setGenerateNewResume] = useState(false);
	const [showResumePrintPopup, setShowResumePrintPopup] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isDownloadingExistingResume, setIsDownloadingExistingResume] = useState(false);
	const [printOldResume, setPrintOldResume] = useState(false);
	let extrasSectionsChecks = [];
	const [showMessage, setShowMessage] = useState(false);
	const [resultMessage, setResultMessage] = useState("");
	const [downloadLoading, setDownloadLoading] = useState(false);

	let useTemplateName = resumeData.selectedTemplate.templateName;

	if (resumeData.journal) {
		//if contains q substring from q_to_end
		const indexOfq = resumeData.journal.templateId.indexOf("q");
		let intermediateName = resumeData.journal.templateId;

		if (indexOfq >= 0) {
			intermediateName = intermediateName.substring(indexOfq + 1);
		}

		//replace x with _
		intermediateName = intermediateName.replaceAll("x", "_");

		useTemplateName = intermediateName;
	}
	let Sections = [
		"PERSONAL",
		"REFERENCE",
		"LINKS",
		"AFFILIATION",
		"ADDITIONAL_INFO",
		"CUSTOM",
		"LANGUAGES",
		"ACHIEVEMENTS",
		"CERTIFICATION",
	];
	let ResumeMapping = [
		"PERSONALPROFILE",
		"REFERENCES",
		"PERSONALLINKS",
		"AFFILIATIONS",
		"ADDITIONALINFO",
		"CUSTOMEXTRAS",
		"LANGUAGES",
		"ACCOMPLISHMENTS",
		"CERTIFICATIONS",
	];

	function switchToCreateResume() {
		setresumeGenerated(false);
		setPrintOldResume(false);
		setGenerateNewResume(true);
	}

	function navigateToViewPdf(url, title) {
		return navigate("/view-pdf", {
			state: {
				pdfUrl: url,
				pdfTitle: title,
			},
		});
	}

	function handleCheck(section) {
		if (extrasSectionsChecks[section] === "checked") {
			extrasSectionsChecks.splice(section, 1);
		} else {
			extrasSectionsChecks[section] = "checked";
		}
	}

	function downloadExistingResume(resumeId) {
		setIsDownloadingExistingResume(true);
		resumeDataService.getResumePrintoutById(
			{ resumeId: resumeId },
			(res) => {
				setresumeGenerated(true);
				let url = res.data.url;
				let title = res.data.fullNname;

				navigateToViewPdf(url, title);
			},
			() => {
				toast.error("Something went wrong, please try again");
				setIsDownloadingExistingResume(false);
			},
		);
	}

	//this logic will be moved somewhere else
	function downloadResume(resumeId) {
		setShowResumePrintPopup(true);
		setResumeIdCookie(resumeId);
		setDownloadLoading(true);
		resumeDataService.getResumePrintoutById(
			{ resumeId: resumeId },
			(res) => {
				setDownloadLoading(false);
				setresumeGenerated(true);
				let url = res.data.url;
				let title = res.data.fullNname;
				let printCreated = new Date(res.data.createdAt);
				let resumeUpdated = new Date(lastUpdatedOn);

				// window.open(url, &#39;_blank&#39;);
				if (printCreated > resumeUpdated) {
					navigateToViewPdf(url, title);
				} else {
					setGenerateNewResume(false);
					setPrintOldResume(true);
					setIsLoading(false);
				}
			},
			(err) => {
				setDownloadLoading(false);
				if (err.response.status === 404) {
					setGenerateNewResume(true);
					setIsLoading(false);
				}
			},
		);
	}

	// const [successMessage, setSuccessMessage] = useState();

	function createResumeDownload(resumeId) {
		let removeSections = [];

		extrasSections.map((section) => {
			let sectionCheck = document.getElementById(section);
			if (sectionCheck.checked) {
				let indexForSection = ResumeMapping.indexOf(section.toUpperCase());
				removeSections.push(Sections[indexForSection]);
			}
		});

		let printResumeButton = document.getElementById("create-resume");
		printResumeButton.disabled = true;
		printResumeButton.style.display = "none";
		setresumeGenerateSpinner(true);

		resumeDataService.putResumePrintout(
			{
				resumeId: resumeId,
				payload: {
					templateName: useTemplateName,

					excludedExtraSections: removeSections,
				},
			},
			(res) => {
				let url = res.data.url;
				let title = res.data.fullNname;
				navigateToViewPdf(url, title);
			},
			(err) => {
				if (err.response.status === 402) {
					setShowMessage(true);
					//These messages will be collected in one place, and we will use message codes to display them
					setResultMessage("You do not have a valid subscription. Please click on the link below");

					setTimeout(() => {
						navigate("/payments");
					}, 3000);
				}
				// redirect to http://localhost:3000/subscription-options  402
			},
		);
	}

	// const buttonRef = useRef();

	// const [, setLoadingPreview] = useState(false);

	// function openResumePreview(resumeId, resumeJournalId) {
	//     setResumeIdCookie(resumeId);
	//
	//     if (resumeData.journal._id === resumeJournalId) {
	//         return buttonRef.current.click();
	//     }
	//     if (resumeData.journal._id !== resumeJournalId) {
	//         setLoadingPreview(true);
	//         fetchResumeData(resumeId, () => {
	//             buttonRef.current.click();
	//             setLoadingPreview(false);
	//         });
	//     }
	// }

	const downloadResumeModal = () => {
		return (
			<Modal
				isOpen={generateNewResume || showResumePrintPopup}
				onClose={() => {
					setGenerateNewResume(false);
					setShowResumePrintPopup(false);
					setPrintOldResume(false);
					setShowResumePrintPopup(false);
					setIsLoading(true);
				}}
				title={printOldResume || isLoading ? "Download Your Resume" : "Keep Only What Matters for Your Resume (PDF)"}
				size="xl"
				titleClassName="flex items-center h-10"
			>
				{isLoading && (
					<div className="d-flex mx-5 mt-5 align-center justify-content-center">
						<Loader />
					</div>
				)}
				{!isLoading && (
					<>
						{generateNewResume && (
							<GenerateResumePopup
								resume={resume}
								resumeGenerateSpinner={resumeGenerateSpinner}
								createResumeDownload={createResumeDownload}
								showMessage={showMessage}
								resultMessage={resultMessage}
								extrasSections={extrasSections}
								handleCheck={handleCheck}
							/>
						)}
						{printOldResume && (
							<div className="p-3">
								<p className="mb-3">
									You&apos;ve made changes since your last PDF was generated. What would you like to do?
								</p>
								<Button
									disabled={isDownloadingExistingResume}
									type="button"
									className="bg-primary rounded-none mt-3 mr-3"
									onClick={() => downloadExistingResume(resume.id)}
								>
									{isDownloadingExistingResume ? (
										<>
											Loading <Spinner />
										</>
									) : (
										"Download Previous PDF"
									)}
								</Button>
								<Button
									type="button"
									className="bg-primary rounded-none mt-3"
									onClick={() => switchToCreateResume(resume.id)}
								>
									Generate Updated PDF
								</Button>
							</div>
						)}
					</>
				)}
			</Modal>
		);
	};

	return { downloadResumeModal, downloadResume, showResumePrintPopup, downloadLoading };
};

export default useMyResumesUtilities;
